import Box from "@mui/material/Box";
import type { ResponsiveTextProps } from "../types";

/** ADR-20261102-h2fd: wording H2 shortens below 600px. Only one form is ever rendered visible or
 * announced (the other is display: none). */
export function ResponsiveText({ narrow, wide }: Readonly<ResponsiveTextProps>) {
  return (
    <>
      <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
        {narrow}
      </Box>
      <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
        {wide}
      </Box>
    </>
  );
}
